// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1SMSo","savePackageButton":"ClientWallet_savePackageButton__xi5g6"};